/**
 * Converts a given value from string to boolean
 *
 * @param {string | undefined} value Given string value
 * @returns {boolean} Converted boolean value
 */
export const parseBool = (value: string | undefined): boolean => {
  try {
    const convertedValue = value && JSON.parse(value.toLowerCase());
    return !!convertedValue;
  } catch {
    return false;
  }
};

/**
 * Performs positional formatting of the string with given parameters
 * @example
 *  template: "The {0} brown {1} jumped over the {2} {3}"
 *  params: [
 *            "quick",
 *            "dog",
 *            "lazy",
 *            "fox",
 *          ]
 *  returns: "The quick brown dog jumped over the lazy fox"

 * @param {string} template String to be formatted
 * @param {string[]} params Positional params to be formatted within the template
 * @returns {string} The formatted string
 */
export const format = (template: string, ...params: string[]): string => {
  let formattedString = template;
  params.forEach((param: string, index: number) => {
    formattedString = formattedString.replace(new RegExp(`\\{${index}\\}`, "g"), param);
  });

  return formattedString;
};
